export const environment = {
  production: false,
  SW: true,
  URL_FRONT: 'https://corpcentralremuneraciones.csff.cl',
  OTHERS: {
  },
  API_DOMAINS: {
    URL_USER: '',
    OTIC_CR: 'https://api-corp-cent-rem-qa.csff.cl/cent-remu',
    USUARIOS: 'https://api-corp-cent-rem-qa.csff.cl/usuarios',
    COMUNES: 'https://api-corp-cent-rem-qa.csff.cl/comunes',
  },
  AUTH_DOMAIN: 'https://conecta-qa.0s.cl/bienvenido',
  sso: {
    realm: 'CORPORACION',
    url: 'https://sso-qa.csff.cl',
    sslRequired: 'external',
    resource: 'centralizacion-front',
    publicClient: true,
    confidentialPort: 0,
  },
  push: {
    vapidPublicKey:
      'BJ81JiROOOdvwk9s3gOKi0t37zFFKYtzlhX8kLvKjJkc3f1sDqYi1OV54T9YSuFXbI8HrYUnneke5ycJncsxQTc',
  },
};
